import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { SupportedLanguage } from 'featureSliced/shared/utils/localization/i18n'
import { IAllergen, initialState, ITable } from './types'

// import moment from 'moment'
// // @ts-ignore
// import de from 'moment/locale/de'
// // @ts-ignore
// import en from 'moment/locale/en-gb'
// // @ts-ignore
// import fr from 'moment/locale/fr'
// // @ts-ignore
// import it from 'moment/locale/it'
export const CommonSlice = createSlice({
  name: 'commonSlice',
  initialState,
  reducers: {
    setSelectedLanguage(state, action: PayloadAction<SupportedLanguage>) {
      state.selectedLanguage = action.payload
    },
    setAllowedLanguages(state, action: PayloadAction<SupportedLanguage[]>) {
      state.allowedLanguages = action.payload
    },
    setIsTopScrolled(state, action: PayloadAction<boolean>) {
      state.isTopScrolled = action.payload
    },
    setAllergens(state, action: PayloadAction<IAllergen[]>) {
      state.allergens = action.payload
    },
    setTableData(state, action: PayloadAction<ITable>) {
      state.tableData = action.payload
    },
  },
})

export default CommonSlice.reducer
